import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import Logo from '../../images/logo/Logo.svg';
import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';

const contentVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

const contentTransition = {
  type: 'spring',
  stiffness: 120,
  damping: 20,
  duration: 0.3,
};


const Role = () => (
  <motion.div
    variants={contentVariants}
    initial="initial"
    animate="in"
    exit="out"
    transition={contentTransition}
  >
    <Box sx={styles.mainContainer}>
      <Card sx={styles.card}>
        <CardContent sx={styles.cardContent}>
          <Box sx={styles.logoBox}>
            <img src={Logo} alt="Logo" style={styles.logoImage} />
          </Box>
          <Box sx={styles.buttonGroup}>
            <Link
              to="/signup"
              state={{ role: 'ROLE_PROVIDER' }}
              style={{ textDecoration: 'none' }}
            >
              <Button sx={styles.serviceProviderButton}>Service Provider</Button>
            </Link>
            <Link
              to="/signup"
              state={{ role: 'ROLE_USER' }}
              style={{ textDecoration: 'none' }}
            >
              <Button sx={styles.customerButton}>Customer</Button>
            </Link>
          </Box>
          <Box>
            <Typography sx={styles.typography}>
              Your One-Stop Solution for Home Construction, Interiors, Renovations.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
    </motion.div>
);

export default Role;

const styles = {
  mainContainer: {
    display: 'flex',
    height: { xs: '90vh', md: '100vh' },
    alignItems: 'center',
    justifyContent: 'center',
    p: { xs: 1, md: 2 },
  },
  card: {
    boxShadow: '0px 0px 4px 0px #00000033',
    maxWidth: 500,
    width: '90%',
    p: 2,
    borderRadius: '20px',
  },
  cardContent: {
    my: 6,
  },
  logoBox: {
    display: 'flex',
    justifyContent: 'center',
    mb: 3,
  },
  logoImage: {
    width: '160px',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'center',
    alignItems: 'center',
    mb: 3,
    gap: { xs: 2, md: 5 },
  },
  serviceProviderButton: {
    textTransform: 'capitalize',
    fontSize: { xs: '16px', md: '16px' },
    fontWeight: 500,
    borderRadius: '28px',
    color: 'black',
    border: '1px solid black',
    py: 0.7,
    px: { xs: 2, md: 3 },
  },
  customerButton: {
    textTransform: 'capitalize',
    fontSize: { xs: '16px', md: '16px' },
    fontWeight: 500,
    borderRadius: '28px',
    bgcolor: '#B69D74',
    color: 'white',
    py: 0.7,
    px: { xs: 5, md: 5 },
  },
  typography: {
    maxWidth: 300,
    mx: 'auto',
    fontSize: { xs: '16px', md: '17px' },
    fontWeight: 400,
    textAlign: 'center',
  },
};